import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const addPatientEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_PATIENT();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error posting data: ${error.message}`);
  }
};

export const updatePatientEndpoint = async (data, patientId) => {
  const endpoint = API_ENDPOINTS.UPDATE_PATIENT(patientId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating patient: ${error.message}`);
  }
};

export const deletePatientEndpoint = async patientId => {
  // Assuming API_ENDPOINTS.DELETE_PATIENT() returns the endpoint URL and accepts a patient ID
  const endpoint = API_ENDPOINTS.DELETE_PATIENT(patientId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    throw new Error(`Error deleting patient: ${error.message}`);
  }
};
